import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Button } from 'react-bootstrap';
import { merge } from 'lodash';
import moment from 'moment';
import { colours } from './../helpers';
import ActionButtonListComponent from './../Components/ActionButtonListComponent';

const ArtifactList = ({ artifacts, style }) => (
  <ul style={merge(style || {}, { paddingLeft: '20px' })}>
    {
      artifacts.map((a, i) => (<li key={i}>{a}</li>))
    }
  </ul>
);

ArtifactList.propTypes = {
  artifacts: PropTypes.arrayOf(PropTypes.string).isRequired,
  style: PropTypes.object
};

const ArtifactHealthApplicationComponent = ({
  axiomVersion,
  actions,
  appSupportId,
  artifacts,
  currentPublicVersion,
  currentSupportedVersion,
  id,
  lastGeneratedDate,
  latestDataVersion,
  latestSupportedDate,
  missingArtifacts,
  name,
  onActionButtonClick,
  platform,
  tier,
  status,
  onClick
}) => (
  <div>
    <Row>
      <Col md={4}>
        <h4>Metadata</h4>
        <hr />
        <table>
          <tbody>
            <tr>
              <td>Current supported version:</td>
              <td>{currentSupportedVersion}</td>
            </tr>
            <tr>
              <td>Last diffed version:</td>
              <td>{latestDataVersion}</td>
            </tr>
            <tr>
              <td>Current public version:</td>
              <td>{currentPublicVersion}</td>
            </tr>
            <tr>
              <td>Axiom version:</td>
              <td>{axiomVersion}</td>
            </tr>
            <tr>
              <td>Latest supported date:</td>
              <td>{moment(latestSupportedDate).format('YYYY-MM-DD')}</td>
            </tr>
            <tr>
              <td>Last generated date:</td>
              <td>{moment(lastGeneratedDate).format('YYYY-MM-DD')}</td>
            </tr>
            <tr>
              <td>Tier:</td>
              <td>{tier}</td>
            </tr>
          </tbody>
        </table>
      </Col>
      <Col md={4}>
        <h4>Artifacts</h4>
        <hr />
        <ArtifactList artifacts={artifacts} />
      </Col>
      <Col md={3}>
        <h4>Missing Artifacts</h4>
        <hr />
        <ArtifactList artifacts={missingArtifacts}
          style={{ color: colours.colours.red }}
        />
      </Col>
      <Col md={1}>
        <ActionButtonListComponent
          actions={actions}
          onButtonClick={onActionButtonClick}
          itemId={id}
        />
      </Col>
    </Row>
    {status !== 5 ? (
      <div>
        <br />
        <Button
          id = {`verify-application-button-${name}`}
          hidden={status !== 2}
          onClick={() => onClick({
            appSupportId: appSupportId,
            status: 5,
            name: name,
            platform: platform,
            tier: tier,
            latestDataVersion: latestDataVersion,
            currentPublicVersion: currentPublicVersion,
            lastGeneratedDate: lastGeneratedDate,
            artifacts: artifacts,
            axiomVersion: axiomVersion
          })}
        >
          Verify Application
        </Button>
      </div>) : null}
  </div>
);

ArtifactHealthApplicationComponent.propTypes = {
  actions: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.object)),
  appSupportId: PropTypes.number.isRequired,
  artifacts: PropTypes.arrayOf(PropTypes.string).isRequired,
  axiomVersion: PropTypes.string.isRequired,
  currentPublicVersion: PropTypes.string.isRequired,
  currentSupportedVersion: PropTypes.string.isRequired,
  id: PropTypes.number,
  lastGeneratedDate: PropTypes.string.isRequired,
  latestDataVersion: PropTypes.string.isRequired,
  latestSupportedDate: PropTypes.string.isRequired,
  missingArtifacts: PropTypes.arrayOf(PropTypes.string).isRequired,
  name: PropTypes.string,
  onActionButtonClick: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
  platform: PropTypes.string.isRequired,
  status: PropTypes.number.isRequired,
  tier: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
};

export default ArtifactHealthApplicationComponent;


// WEBPACK FOOTER //
// src/Components/ArtifactHealthApplicationComponent.jsx